import { cloneElement, ReactElement } from 'react';
import overlay, { useOverlaySubscriber } from '@activebrands/core-web/libs/overlay';

interface OverlayTriggerProps {
    children: ReactElement;
    closeOthers?: boolean;
    mode?: 'open' | 'toggle';
    overlayId: string;
    overlayProps?: Record<string, unknown>;
}

const OverlayTrigger = ({
    children,
    closeOthers = false,
    mode = 'open',
    overlayId,
    overlayProps,
}: OverlayTriggerProps) => {
    const isOpen = useOverlaySubscriber(overlayId);

    const handleClick = (e: React.MouseEvent) => {
        children.props.onClick?.(e);

        if (mode === 'toggle' && isOpen) {
            overlay.close(overlayId);
            return;
        }

        if (closeOthers) {
            overlay.closeAll();
        }
        overlay.open(overlayId, overlayProps);
    };

    return cloneElement(children, {
        'aria-expanded': isOpen,
        'aria-controls': `overlay-${overlayId}`,
        'aria-haspopup': 'dialog',
        onClick: handleClick,
    });
};

export default OverlayTrigger;
